import {PRODUCTION, DEVELOPMENT, STAGING, LOCAL} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

export const getBrazeApiKey = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "48fae39e-66d6-425d-ac0c-b5940ec4a609"
  }
  return "656bc815-77b1-445f-9752-c7defacef0f1"
}

export const sdkEndpoint = "sdk.fra-01.braze.eu"

export const isLoggingEnabled = [STAGING, DEVELOPMENT, LOCAL].includes(env.ENVIRONMENT_NAME)
